import FilledCheck from "images/Icons/FilledCheck.inline.svg"
import XIcon from "images/Icons/XL.inline.svg"
import { css, fresponsive, styled } from "library/styled"
import type { ReactNode } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"

const COLOR_LIBRARY = {
	before: {
		color: colors.orange,
		background:
			"linear-gradient(180deg, rgba(255, 255, 255, 0.4) -48.96%, rgba(216, 121, 6, 0.2) 166.67%)",
	},
	after: {
		color: colors.green400,
		background:
			"linear-gradient(180deg, rgba(255, 255, 255, 0.4) -48.96%, rgba(48, 113, 93, 0.2) 166.67%)",
	},
}

export default function Tag({
	children,
	variant = "before",
}: {
	children: ReactNode
	variant?: "before" | "after"
}) {
	return (
		<Wrapper variant={variant} className="tag-wrapper">
			<Pill variant={variant} className="tag-pill">
				<Icon variant={variant}>
					<XIconStyled className="x-icon" />
					<FilledCheckStyled className="filled-check-icon" />
				</Icon>
				<Text variant={variant} className="tag-text">
					{children}
				</Text>
			</Pill>
		</Wrapper>
	)
}

const Wrapper = styled(
	"div",
	({ variant }: { variant: "before" | "after" }) => {
		const { color } = COLOR_LIBRARY[variant]

		return {
			...fresponsive(css`
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				width: fit-content;
				border-radius: 99vw;
				height: fit-content;
				border: 1px dashed ${color};
				padding: 4px;
			`),
		}
	},
)

const Pill = styled("div", ({ variant }: { variant: "before" | "after" }) => {
	const { background } = COLOR_LIBRARY[variant]

	return {
		...fresponsive(css`
			position: relative;
			border-radius: 99vw;
			width: 100%;
			z-index: 1;
			display: flex;
			place-items: center;
			gap: 2px;
			padding: 6px 8px 6px 6px;
			height: 24px;
			background: ${background};
			box-shadow: 0 4px 4px 0 rgba(255 255 255 / 25%) inset;
		`),
	}
})

const Text = styled("span", ({ variant }: { variant: "before" | "after" }) => {
	const { color } = COLOR_LIBRARY[variant]

	return {
		...fresponsive(css`
			position: relative;
			${textStyles.custom.bodyXXS};
			padding: 4px 0;
			margin: -4px 0;
			color: ${color};
			z-index: 2;
		`),
	}
})

const Icon = styled("div", ({ variant }: { variant: "before" | "after" }) => {
	const { color } = COLOR_LIBRARY[variant]

	return {
		...fresponsive(css`
			position: relative;
			width: 12px;
			height: 12px;
			color: ${color};
			margin-right: 4px;

			.x-icon {
				opacity: ${variant === "before" ? 1 : 0};
			}

			.filled-check-icon {
				opacity: ${variant === "after" ? 1 : 0};
			}
		`),
	}
})

const XIconStyled = styled(XIcon, {
	...fresponsive(css`
		position: absolute;
		width: 12px;
		height: 12px;
		color: ${colors.orange};
	`),
})

const FilledCheckStyled = styled(FilledCheck, {
	...fresponsive(css`
		position: absolute;
		opacity: 0;
		width: 12px;
		height: 12px;
		color: ${colors.green400};
	`),
})
